import React from 'react';

const OfflineIconDouble = (props) => {
  let { 
    height, 
    width, 
    iconColor,
  } = props;
  
  return (

    <svg xmlns="http://www.w3.org/2000/svg"
      width={width ? width : '154'} 
      height={height ? height : '117'} 
      viewBox="0 0 154 117"
    >
      <path 
        fill="none" 
        fillRule="nonzero" 
        stroke={iconColor} 
        strokeWidth="5" 
        d="M36.053 44.939a13.765 13.765 0 0 1-.117-1.412 33.408 33.408 0 0 1-.017-1.35C35.919 
        20.273 54.386 2.5 77.03 2.5c11.44 0 22.155 4.561 29.866 12.463l1.58 1.62-80.914 96.43-1.634-.576a35.946 
        35.946 0 0 1-5.35-2.393C9.514 103.966 2.5 92.586 2.5 80.044c0-18 14.488-33.1 
        32.923-34.385.154-.011.324-.103.507-.307.067-.075.124-.241.123-.413zm81.196-10.742c.56 2.65.84 5.364.832 
        8.105 0 .774-.04 1.502-.132 2.707-.015.19.046.386.12.47l.077.089c.1.122.262.203.425.216 18.441 1.285 32.929 
        16.324 32.929 34.26 0 19.013-15.969 34.456-35.543 34.456H44.591l71.596-85.324 1.062 5.02z"
      />
    </svg>

  );
};
export default OfflineIconDouble;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/OfflineIconDouble/index.js